export enum UserRoleType  {
  SUPPORT = 'SUPPORT', 
  GA_EDITOR = 'GA_EDITOR',
  INCIDENT_EDITOR = 'INCIDENT_EDITOR',
  ANALYST = 'ANALYST',
  WFDSS_VIEWER = 'WFDSS_VIEWER'
}

// MM 4.20.22, this was the old and long list of roles. Removed to make 
// DISABLED,
// VIEWER,
//  AUTHOR,
//   NATIONAL_EDITOR,
//    FIRE_BEHAVIOR_SPECIALIST,
//     SUPER_ANALYST,
//      ADMINISTRATOR,
//      REGIONAL_GEOGRAPHIC_AREA_EDITOR,
//       DISPATCHER,
//        ANONYMOUS,
//         HELP_DESK,
//          DATA_MANAGER,
//           APPLICATION_SUPPORT,
//            FEEDBACK

